/**
 * Formats quick search location strings into an object for advanced search.
 *
 * @param {string} sLocation - Quick search location name
 * @param {array} aStateList - REGION code table
 * @param {array} aCountryList - COUNTRY code table
 * @returns {object}
 */
export const fnFormatQuickSearchLocationForAdvSearch = (
  sLocation = '',
  aStateList = [],
  aCountryList = []
) => {
  if (!sLocation) {
    return {};
  }

  const oResult = {};

  // Example: 'Winston-Salem, North Carolina (NC), United States (USA)'
  const [sCity, sStatePart, sCountryPart] = sLocation.split(', ');

  oResult.city = sCity;

  const sStateAbbrv = sStatePart.slice(-3, -1);
  const oState = aStateList.find(
    (item) => item.DETAILS.STATE_ABBRV === sStateAbbrv
  );
  if (oState) {
    oResult.state = { ID: oState.ID, DESCRIPTION: oState.DESCRIPTION };
  }

  const [sCountryName] = sCountryPart.split(' (');
  const oCountry = aCountryList.find(
    (item) => item.DESCRIPTION === sCountryName
  );
  if (oCountry) {
    oResult.country = { ID: oCountry.ID, DESCRIPTION: oCountry.DESCRIPTION };
  }

  return oResult;
};

/**
 * Where to return to when closing advanced search. Deep-linked opens land
 * directly on /main/search?..., so the search URL itself can't be the
 * origin — fall back to /main in that case.
 *
 * @param {object} oLocation - react-router location ({ pathname, search }).
 * @returns {string}
 */
export const fnComputeSearchOrigin = (oLocation) => {
  const bOnSearchUrl =
    oLocation.pathname.includes('/search') && !!oLocation.search;
  return bOnSearchUrl ? '/main' : `${oLocation.pathname}${oLocation.search}`;
};

export const oEmptyAdvancedSearch = {
  firstname: '',
  lastname: '',
  city: '',
  state: { ID: null, DESCRIPTION: '' },
  country: { ID: null, DESCRIPTION: '' },
  classof: '',
  employer: { NAME: '', LOOKUPID: '' },
  includeformeremployers: false,
  educationalprogram: { ID: null, DESCRIPTION: '' },
  educationalinvolvement: { ID: null, DESCRIPTION: '' },
  educationaldepartment: { ID: null, DESCRIPTION: '' },
  affinitygroup: { ID: null, DESCRIPTION: '' },
  industry: { ID: null, DESCRIPTION: '' },
};
